import styles from './BoardListSkeleton.module.css';
import classNames from 'classnames/bind';
import { Skeleton } from 'antd';

const cx = classNames.bind(styles);

interface IBoardListSkeleton {
  dataLength?: number;
}

function BoardListSkeleton({ dataLength = 9 }: IBoardListSkeleton) {
  return (
    <div className={cx('wrapper')}>
      <ul className={cx('list')}>
        {new Array(dataLength).fill(0).map((_, index) => (
          <li key={index}>
            <div className={cx('image-wrapper')} />
            <Skeleton.Input size="small" className={cx('text')} />
            <Skeleton.Input size="small" className={cx('text')} />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default BoardListSkeleton;
